export const TEST_ID = 'simpleLayout';
